import { render } from "./MyNfts.vue?vue&type=template&id=89a5447c"
import script from "./MyNfts.vue?vue&type=script&lang=ts"
export * from "./MyNfts.vue?vue&type=script&lang=ts"
script.render = render

export default script